var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverToZoomNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.67,
    height: 10.67,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43335 3.44287V6.64287",
    stroke: "#535353",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0335 5.04272H3.8335",
    stroke: "#535353",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 11.4428L8.44995 8.05933",
    stroke: "#535353",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43341 9.30946C7.78983 9.30946 9.70008 7.3992 9.70008 5.04279C9.70008 2.68637 7.78983 0.776123 5.43341 0.776123C3.077 0.776123 1.16675 2.68637 1.16675 5.04279C1.16675 7.3992 3.077 9.30946 5.43341 9.30946Z",
    stroke: "#535353",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverToZoomNew);
export default __webpack_public_path__ + "static/media/hover-to-zoom-new.ba17532432c42e41e57419bb634fe9fc.svg";
export { ForwardRef as ReactComponent };